import styled from 'styled-components'
import { ControlSize } from 'types'
import { IconButton } from 'ui'
import { fontShadowFromControlSize } from 'utils'

export const Pause = styled(IconButton)<{ size: ControlSize }>`
    bottom: 10px;
    filter: drop-shadow(${({ size }) => fontShadowFromControlSize(size)});
    left: 10px;
    opacity: 0;
    position: absolute;
    transition: opacity 0.15s ease-out 3s;
`

export const Container = styled.div`
    background-color: #000;
    background-image: linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%),
        linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%);
    background-size: 24px 24px;
    background-position: 0 0, 12px 12px;
    border-radius: 6px;
    margin: 0 auto;
    position: relative;

    &:hover ${Pause} {
        opacity: 1;
        transition-delay: 0s;
    }
`

export const Wrapper = styled.div`
    position: relative;
`
